import { defineComponent as g, computed as m } from "vue";
import { MsArrow as l, MsArrowRight as M, MsArrowLeft as d } from "@sunrise/icons";
import { screenSizeDetection as b } from "@sunrise/shared";
const A = g({
  name: "CsLinearPagination",
  components: {
    MsArrowLeft: d,
    MsArrowRight: M,
    MsArrow: l
  },
  props: {
    current: {
      type: Number,
      required: !0
    },
    last: {
      type: Number,
      required: !0
    }
  },
  emits: ["update:current"],
  setup(e, { emit: n }) {
    const { isScreenM: t } = b(), i = m(() => h(e.current, e.last, t.value ? 7 : 4)), r = async (a) => {
      n("update:current", a);
    }, s = m(() => e.current <= 1), c = m(() => e.current >= e.last);
    return {
      isScreenM: t,
      pages: i,
      pageClick: r,
      isFirstPage: s,
      isLastPage: c
    };
  }
}), h = (e, n, t) => {
  const i = Math.floor(t / 2);
  let r = Math.max(1, e - i);
  const s = Math.min(n, r + t - 1);
  s >= n && (r = Math.max(1, s - t + 1));
  const c = s - r + 1, a = [];
  for (let u = 0; u < c; u++) {
    const o = r + u, p = o === e, f = p ? `Aktuelle Seite, Seite ${o}` : `Zur Seite ${o}`;
    a.push({
      page: o,
      isCurrent: p,
      ariaLabel: f
    });
  }
  return a;
};
export {
  A as default
};
